import jsonata from 'jsonata'

function getOffset(): string {
  const offsetMinutes = new Date().getTimezoneOffset()
  const absMinutes = Math.abs(offsetMinutes)
  const sign = offsetMinutes <= 0 ? '+' : '-'
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0')
  const minutes = String(absMinutes % 60).padStart(2, '0')
  return `${sign}${hours}${minutes}`
}

const extendedJsonata = (expr: string) => {
  const expression = jsonata(expr)
  expression.registerFunction('bcOffset', getOffset)
  return expression
}

export { extendedJsonata as jsonata }
